import { jsx as t, Fragment as f, jsxs as d } from "react/jsx-runtime";
import { Box as u, Typography as e, Stack as y, Chip as h } from "@mui/material";
import { s as g, l as x, m as C, k as D } from "../../index-DVHhaa_b.js";
import { prettyDateRange as S } from "../../helpers/dates.js";
import "../../queries/message/index.js";
import "../../queries/contact/index.js";
import "../../queries/calendars/index.js";
import { student as T } from "../../queries/student/index.js";
import "../../queries/settings/index.js";
import "../../queries/points/index.js";
import "../../queries/assessment/index.js";
import "../../queries/assessment/annotations/index.js";
import "../../queries/assessment/rubrics/index.js";
import "../../queries/assessment/qcesubjects/index.js";
import "../../queries/assessment/extensionrequest/index.js";
import "../../queries/files/index.js";
import "../../queries/attendance/index.js";
import "../../queries/forms/index.js";
import "../../queries/notifications/index.js";
import "../../queries/interviews/index.js";
import "../../queries/notes/index.js";
import "../../queries/annoucements/index.js";
import "../../queries/payments/index.js";
import "../../queries/assessment/analysis/index.js";
import "../../queries/group/index.js";
import "../../queries/projects/index.js";
import "../../queries/courses/index.js";
import "../../queries/password/index.js";
import { DaymapSkeleton as v } from "../skeletons/index.js";
function tt({ studentId: n, year: o, onClassClick: a }) {
  const p = (/* @__PURE__ */ new Date()).getFullYear(), m = !o || o === "current", s = !o || o === "current" ? p : o, { data: i, isPending: l } = new T.ClassesByYear({
    studentId: Number(n),
    year: s,
    current: m
  }).ToQuery();
  return l ? /* @__PURE__ */ t(v, { type: "listitems" }) : !i || i.length === 0 ? /* @__PURE__ */ t(u, { sx: { textAlign: "center", py: 4 }, children: /* @__PURE__ */ t(e, { variant: "body2", color: "text.secondary", children: "No classes found for this year" }) }) : /* @__PURE__ */ t(f, { children: i.map((r) => /* @__PURE__ */ t(
    g,
    {
      title: r.ClassDisplayName,
      onClick: () => {
        const c = o === "current" ? void 0 : o;
        a(r.ClassID, c);
      },
      description: /* @__PURE__ */ d(y, { direction: "row", alignItems: "center", spacing: 1, children: [
        /* @__PURE__ */ t(h, { label: r.Subject, size: "small" }),
        /* @__PURE__ */ t(D, { staffId: r.StaffID, label: r.Staff.DisplaynameSurname }),
        /* @__PURE__ */ t(e, { variant: "body2", sx: { fontSize: ".85rem", color: "var(--mui-palette-text-secondary)", textAlign: "right", flex: 1 }, children: S(r.FirstEventStartTime, r.LastEventEndTime, { showTime: !1 }) })
      ] }),
      avatar: /* @__PURE__ */ t(x, { iconType: C.Class })
    },
    r.ClassID
  )) });
}
export {
  tt as ClassesList
};
//# sourceMappingURL=ClassesList.js.map
